import { useEffect, useState } from 'react';
import { formatDate } from '../../utils/formatters';

const STATUS_OPTIONS = [
  { value: 'NEW', label: 'חדש' },
  { value: 'IN_PROGRESS', label: 'בטיפול' },
  { value: 'RESOLVED', label: 'טופל' },
];

const SUBJECT_LABELS = {
  PERMANENTLY_CLOSED: 'המקום סגור לצמיתות',
  OPENING_HOURS_INCORRECT: 'שעות הפתיחה לא נכונות',
  NAME_INCORRECT: 'שם המקום לא נכון',
  ADDRESS_INCORRECT: 'הכתובת לא נכונה',
  LOCATION_INCORRECT: 'המיקום במפה לא נכון',
  DUPLICATE_PLACE: 'המקום מופיע יותר מפעם אחת',
  OTHER: 'נושא אחר',
};

const ReportDialog = ({ report, open, onClose, onSave, loading }) => {
  const [form, setForm] = useState({ status: 'NEW', resolution: '' });
  const [error, setError] = useState('');

  useEffect(() => {
    if (!report) return;
    setForm({ status: report.status || 'NEW', resolution: report.resolution || '' });
    setError('');
  }, [report]);

  if (!open || !report) return null;

  const submit = async (event) => {
    event.preventDefault();
    if (form.status === 'RESOLVED' && !form.resolution.trim()) {
      setError('כדי לסמן את הדיווח כטופל צריך לפרט מה נעשה');
      return;
    }
    await onSave(report.reportId, { status: form.status, resolution: form.resolution.trim() });
    onClose();
  };

  return (
    <div className="modal-backdrop" onMouseDown={onClose}>
      <form
        className="modal report-modal"
        onSubmit={submit}
        onMouseDown={(event) => event.stopPropagation()}
        dir="rtl"
      >
        <header className="modal-header">
          <div>
            <p className="eyebrow">דיווח על מקום</p>
            <h2>{report.placeName}</h2>
            <span>{report.reportId}</span>
          </div>
          <button type="button" className="icon-button" onClick={onClose} aria-label="סגירה">
            ×
          </button>
        </header>

        <section className="modal-body">
          <section className="editor-section">
            <header className="editor-section-header">
              <h3>פרטי הדיווח</h3>
            </header>
            <dl className="report-details-grid">
              <div>
                <dt>מזהה דיווח</dt>
                <dd>{report.reportId}</dd>
              </div>
              <div>
                <dt>Place ID</dt>
                <dd>{report.placeId}</dd>
              </div>
              <div>
                <dt>נושא</dt>
                <dd>{SUBJECT_LABELS[report.subject] || report.subject}</dd>
              </div>
              <div>
                <dt>שם המדווח</dt>
                <dd>{report.reporterName}</dd>
              </div>
              <div>
                <dt>טלפון</dt>
                <dd>
                  <a href={`tel:${report.phone}`}>{report.phone}</a>
                </dd>
              </div>
              <div>
                <dt>נוצר</dt>
                <dd>{formatDate(report.createdAt)}</dd>
              </div>
              <div>
                <dt>עודכן</dt>
                <dd>{formatDate(report.updatedAt)}</dd>
              </div>
            </dl>
            <div className="report-text-block">
              <strong>תוכן הדיווח</strong>
              <p>{report.details}</p>
            </div>
          </section>

          <section className="editor-section">
            <header className="editor-section-header">
              <h3>טיפול בדיווח</h3>
            </header>
            <div className="report-treatment-form">
              <label>
                סטטוס
                <select
                  value={form.status}
                  onChange={(event) =>
                    setForm((current) => ({ ...current, status: event.target.value }))
                  }
                >
                  {STATUS_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </label>
              <label>
                מה נעשה
                <textarea
                  rows="6"
                  value={form.resolution}
                  onChange={(event) => {
                    setForm((current) => ({ ...current, resolution: event.target.value }));
                    setError('');
                  }}
                  placeholder="תיאור הפעולה שבוצעה או הערות לטיפול"
                />
              </label>
              {!!report.handledBy?.name && (
                <p className="muted">טופל לאחרונה על ידי {report.handledBy.name}</p>
              )}
              {!!error && <p className="message error">{error}</p>}
            </div>
          </section>
        </section>

        <footer className="modal-footer">
          <button type="button" className="secondary" onClick={onClose}>
            ביטול
          </button>
          <button disabled={loading}>שמירת טיפול</button>
        </footer>
      </form>
    </div>
  );
};

export { SUBJECT_LABELS, STATUS_OPTIONS };
export default ReportDialog;
